import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChartsModule } from 'ng2-charts';
import { FullCalendarModule } from '@fullcalendar/angular';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { TourNgxBootstrapModule } from 'ngx-tour-ngx-bootstrap';
import { TagInputModule } from 'ngx-chips';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { OnlyJoinedGroupPipe } from 'src/app/pipes/group.pipe';
import { SignInComponent } from './core/authentication/sign-in/sign-in.component';
import { SignUpComponent } from './core/authentication/sign-up/sign-up.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './core/header/header.component';
import { SidebarComponent } from './core/sidebar/sidebar.component';
import { FooterComponent } from './core/footer/footer.component';
import { QuestionsAnswerComponent } from './core/authentication/welcome/questions-answer/questions-answer.component';
import { ChooseProfileComponent } from './core/authentication/welcome/choose-profile/choose-profile.component';
import { PersonalInfoComponent } from './core/authentication/welcome/personal-info/personal-info.component';
import { CommunityGroupsComponent } from './core/authentication/welcome/community-groups/community-groups.component';
import { ProfileComponent } from './core/authentication/profile/profile.component';
import { ProfileSimilarityComponent } from './core/authentication/profile-similarity/profile-similarity.component';
import { ForgetPasswordComponent } from './core/authentication/forget-password/forget-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from './services/api.service';
import { TranslationService } from './services/translation.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from 'src/app/services/intercept.service';
import { AuthguardService } from 'src/app/services/authguard.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPaginationModule } from 'ngx-pagination';
import { CategoriesComponent } from './categories/categories.component';
import { CategoryViewComponent } from './category-view/category-view.component';
import { RoadmapComponent } from './roadmap/roadmap.component';
import { GroupsComponent } from './groups/groups.component';
import { GroupsViewComponent } from './groups-view/groups-view.component';
import { ChallengesComponent } from './challenges/challenges.component';
import { ChallengesViewComponent } from './challenges-view/challenges-view.component';
import { ChallengesNewComponent } from './challenges-new/challenges-new.component';
import { HelpComponent } from './help/help.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { SuggestionsComponent } from './suggestions/suggestions.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { NewActivityComponent } from './addons/new-activity/new-activity.component';
import { ActivityCardComponent } from './addons/activity-card/new-activity.component';
import { NewActivityTimerComponent } from './addons/new-activity-timer/new-activity-timer.component';
import { NewActivityManuallyComponent } from './addons/new-activity-manually/new-activity-manually.component';
import { NewGoalComponent } from './addons/new-goal/new-goal.component';
import { NewOutcomeComponent } from './addons/new-outcome/new-outcome.component';
import { TodayCommitmentsComponent } from './addons/today-commitments/today-commitments.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { ToastrModule } from 'ngx-toastr';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AgmCoreModule } from '@agm/core';
import { ActivitiesComponent } from './activities/activities.component'; 


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SignInComponent,
    SignUpComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    QuestionsAnswerComponent,
    ChooseProfileComponent,
    PersonalInfoComponent,
    CommunityGroupsComponent,
    ProfileSimilarityComponent,
    ProfileComponent,
    ForgetPasswordComponent,
    CategoriesComponent,
    CategoryViewComponent,
    RoadmapComponent,
    GroupsComponent,
    GroupsViewComponent,
    ChallengesComponent,
    ChallengesViewComponent,
    ChallengesNewComponent,
    HelpComponent,
    NotificationsComponent,
    SuggestionsComponent,
    UserProfileComponent,
    NewActivityComponent,
    ActivityCardComponent,
    NewActivityTimerComponent,
    NewActivityManuallyComponent,
    NewGoalComponent,
    NewOutcomeComponent,
    TodayCommitmentsComponent,
    OnlyJoinedGroupPipe,
    ActivitiesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CarouselModule,
    BrowserAnimationsModule,
    ChartsModule,
    FullCalendarModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TourNgxBootstrapModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    TagInputModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    NgxPaginationModule,
    BsDatepickerModule.forRoot(),
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    ToastrModule.forRoot(),
    PopoverModule.forRoot(),
    AutocompleteLibModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBbaCNsZUQr0Q_YjogDJJIZi1chk9ra6Ps"
    }),
  ],
  providers: [
    ApiService,
    TranslationService,
    AuthguardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
